import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import React from 'react';
import styled from 'styled-components';
import {
  maxWidth,
  primaryColor, primaryFont, retina, secondaryFont, wMedium,
} from 'Utils/utilsStyle';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 10px;
  .count {
    color: ${primaryColor};
    font-family: ${secondaryFont};
    font-weight: ${wMedium};
    letter-spacing: -0.42px;
    font-size: 20px;
  }
`;

const Tag = styled.span<{ color: string }>`
  padding: 6px 14px;
  color: ${(props) => props.color};
  border: 1px solid ${(props) => props.color};
  font-family: ${primaryFont};
  font-weight: ${wMedium};
  font-size: 16px;
  letter-spacing: -0.4px;
  border-radius: 6px;
  @media all and (max-width: ${maxWidth}) , ${retina} {
    padding: 3px 14px;
    font-size: 14px;
  }
`;

type Props = {
  tagTitle?: string,
  tagColor?: string,
  count?: number,
  loading?: boolean,
} | typeof defaultProps;

const defaultProps = {
  tagTitle: 'CxO News',
  tagColor: '#8600C1',
  count: 12,
  loading: false,
};

const EngagementSalesTrigger = function EngagementSalesTrigger(props: Props) {
  const {
    tagTitle, tagColor, count, loading,
  } = props;
  return (
    <Wrapper>
      {loading
        ? (
          <span className="resolution-fix engagement-trigger-fix">
            <SkeletonCustom width="300px" height="38px" margin="0px" />
          </span>
        )
        : (
          <Tag color={tagColor || ''}>
            {tagTitle}
          </Tag>
        )}
      <span className="count">{loading ? <SkeletonCustom width="30px" height="30px" margin="0px" /> : count}</span>
    </Wrapper>
  );
};

EngagementSalesTrigger.defaultProps = defaultProps;
export default EngagementSalesTrigger;
